import {
  Briefcase,
  Building2,
  LayoutDashboard,
  Shield,
  Sparkles,
  UserCog,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import { FIELD_TEAM_ASSETS } from './fieldTeamAssets';
import { FUNNEL_TEAM_SLUGS, type FieldTeamSolutionSlug } from './fieldTeamRoutes';

export type FieldTeamSolution = {
  slug: FieldTeamSolutionSlug;
  icon: LucideIcon;
  bar: 'blue' | 'violet' | 'emerald';
  iconTone: 'blue' | 'violet' | 'emerald';
  laptopSrc: string;
  phoneSrc: string;
  laptopAltKey: string;
  phoneAltKey: string;
};

export const FIELD_TEAM_SOLUTIONS: FieldTeamSolution[] = [
  {
    slug: 'sales',
    icon: Briefcase,
    bar: 'blue',
    iconTone: 'blue',
    laptopSrc: FIELD_TEAM_ASSETS.crmDashboard,
    phoneSrc: FIELD_TEAM_ASSETS.mobileDashboard,
    laptopAltKey: 'ftl_asset_crm_dashboard_alt',
    phoneAltKey: 'ftl_asset_mobile_dashboard_alt',
  },
  {
    slug: 'technician',
    icon: Wrench,
    bar: 'violet',
    iconTone: 'violet',
    laptopSrc: FIELD_TEAM_ASSETS.crmDashboard,
    phoneSrc: FIELD_TEAM_ASSETS.mobileAddLead,
    laptopAltKey: 'ftl_asset_crm_dashboard_alt',
    phoneAltKey: 'ftl_asset_mobile_lead_alt',
  },
  {
    slug: 'security',
    icon: Shield,
    bar: 'emerald',
    iconTone: 'emerald',
    laptopSrc: FIELD_TEAM_ASSETS.crmAiInsights,
    phoneSrc: FIELD_TEAM_ASSETS.mobileProfile,
    laptopAltKey: 'ftl_asset_crm_ai_alt',
    phoneAltKey: 'ftl_asset_mobile_profile_alt',
  },
  {
    slug: 'supervisor',
    icon: UserCog,
    bar: 'blue',
    iconTone: 'blue',
    laptopSrc: FIELD_TEAM_ASSETS.crmAiInsights,
    phoneSrc: FIELD_TEAM_ASSETS.mobileDashboard,
    laptopAltKey: 'ftl_asset_crm_ai_alt',
    phoneAltKey: 'ftl_asset_mobile_dashboard_alt',
  },
  {
    slug: 'cleaning',
    icon: Sparkles,
    bar: 'emerald',
    iconTone: 'emerald',
    laptopSrc: FIELD_TEAM_ASSETS.crmDashboard,
    phoneSrc: FIELD_TEAM_ASSETS.mobileProfile,
    laptopAltKey: 'ftl_asset_crm_dashboard_alt',
    phoneAltKey: 'ftl_asset_mobile_profile_alt',
  },
  {
    slug: 'crm',
    icon: LayoutDashboard,
    bar: 'violet',
    iconTone: 'violet',
    laptopSrc: FIELD_TEAM_ASSETS.crmAiInsights,
    phoneSrc: FIELD_TEAM_ASSETS.mobileDashboard,
    laptopAltKey: 'ftl_asset_crm_ai_alt',
    phoneAltKey: 'ftl_asset_mobile_dashboard_alt',
  },
  {
    slug: 'workforce',
    icon: Building2,
    bar: 'blue',
    iconTone: 'blue',
    laptopSrc: FIELD_TEAM_ASSETS.crmDashboard,
    phoneSrc: FIELD_TEAM_ASSETS.mobileAddLead,
    laptopAltKey: 'ftl_asset_crm_dashboard_alt',
    phoneAltKey: 'ftl_asset_mobile_lead_alt',
  },
];

export function getFieldTeamSolution(slug: FieldTeamSolutionSlug): FieldTeamSolution {
  return FIELD_TEAM_SOLUTIONS.find((item) => item.slug === slug) || FIELD_TEAM_SOLUTIONS[0];
}

export function getFieldTeamFunnelSolutions(): FieldTeamSolution[] {
  return FUNNEL_TEAM_SLUGS.map((slug) => getFieldTeamSolution(slug));
}
